'use client'

import { AppWrapper } from '~/components/app-wrapper'
import { SiteFooter } from '~/components/site-footer'
import { DashboardPage } from '~/domains/account/components/dashboard/dashboard'

export const Page = () => (
	<AppWrapper>
		<DashboardPage />
		<SiteFooter />
	</AppWrapper>
)
